var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgX(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.590654 10.1019C0.25074 10.4418 0.243803 11.0454 0.597591 11.3992C0.958315 11.7529 1.56183 11.746 1.89481 11.413L6.00152 7.30632L10.1013 11.4061C10.4481 11.7529 11.0447 11.7529 11.3985 11.3992C11.7523 11.0384 11.7523 10.4488 11.4054 10.1019L7.30568 6.00217L11.4054 1.89546C11.7523 1.54861 11.7592 0.952032 11.3985 0.598245C11.0447 0.244458 10.4481 0.244458 10.1013 0.591308L6.00152 4.69107L1.89481 0.591308C1.56183 0.251395 0.951378 0.237521 0.597591 0.598245C0.243803 0.952032 0.25074 1.56249 0.590654 1.89546L4.69042 6.00217L0.590654 10.1019Z",
    fill: "#EBEBF5",
    fillOpacity: 0.6
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.7946c62a10f46b42839cfaccc7e978c7.svg";
export { ForwardRef as ReactComponent };